import { useFormik } from 'formik';
import React, { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';


const AddCountry = ({ show, handleClose, token, user_id, refresh }) => {

    const [disableSubmit, setDisableSubmit] = useState(false);

    let initialValues = {
        name: "",
        sort_name: "",
        numeric_code: "",
        iso2: "",
        phone_code: "",
        capital: "",
        currency: "",
        currency_name: "",
        currency_symbol: "",
        native: "",
        region: "",
        subregion: "",
        nationality: "",
        latitude: "",
        longitude: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values,{resetForm}) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/country/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    })

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Country</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <InputTextJSX
                                labelText={"Country Name"}
                                nameValue={"name"}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                            />

                            <InputTextJSX
                                labelText={"Short Name"}
                                nameValue={"sort_name"}
                                value={formik.values.sort_name}
                                onChange={formik.handleChange}
                                maxLength={3}
                            />

                            <InputTextJSX
                                labelText={"Numeric Code"}
                                nameValue={"numeric_code"}
                                value={formik.values.numeric_code}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Phone Code"}
                                nameValue={"phone_code"}
                                value={formik.values.phone_code}
                                onChange={formik.handleChange}
                                maxLength={5}
                            />

                            <InputTextJSX
                                labelText={"Capital"}
                                nameValue={"capital"}
                                value={formik.values.capital}
                                onChange={formik.handleChange}
                            />

                            <InputTextJSX
                                labelText={"Currency Code"}
                                nameValue={"currency"}
                                value={formik.values.currency}
                                onChange={formik.handleChange}
                                maxLength={3}
                            />

                            <InputTextJSX
                                labelText={"Currency Name"}
                                nameValue={"currency_name"}
                                value={formik.values.currency_name}
                                onChange={formik.handleChange}
                            />

                            <InputTextJSX
                                labelText={"Currency Symbol"}
                                nameValue={"currency_symbol"}
                                value={formik.values.currency_symbol}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Region"}
                                nameValue={"region"}
                                value={formik.values.region}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Subregion"}
                                nameValue={"subregion"}
                                value={formik.values.subregion}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Nationality"}
                                nameValue={"nationality"}
                                value={formik.values.nationality}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Latitude"}
                                nameValue={"latitude"}
                                value={formik.values.latitude}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />

                            <InputTextJSX
                                labelText={"Longitude"}
                                nameValue={"longitude"}
                                value={formik.values.longitude}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />


                            <div className="row d-flex justify-content-end mt-2">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                        {
                                            disableSubmit ?
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i> Saving...
                                                </>
                                                :
                                                "Add"
                                        }
                                    </button>
                                </div>
                            </div>


                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddCountry